export default {
    feedExportList(state) {
        return state.feedExportList;
    },
}